PageApp.Views.LoginAmnesiaView = Backbone.Marionette.ItemView.extend({
  template: hbs.templates.loginAmnesia,
  initialize: function (options) {
    this.options = options
  },
  serializeData: function () {
    var content = {
      contextPath: myApp.ent.config.get('contextPath')
    }
    content = _.extend(content, this.model.attributes)
    return content
  }
})
